import { useEffect, useState } from "react";
import { useParams, useSearchParams } from "react-router-dom";
import { api } from "@/lib/api";
import { ProductCard } from "@/components/ProductCard";

const METALS = ["22K Gold", "18K Gold", "Platinum"];
const GEMSTONES = ["Diamond", "Kundan", "Polki", "Ruby", "Emerald"];

export default function Shop() {
  const { category } = useParams();
  const [searchParams, setSearchParams] = useSearchParams();
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [metal, setMetal] = useState("");
  const [gemstone, setGemstone] = useState("");
  const [maxPrice, setMaxPrice] = useState("");
  const [sort, setSort] = useState("");

  const search = searchParams.get("search") || "";

  useEffect(() => {
    setLoading(true);
    const params = { limit: 60 };
    if (category) {
      if (category === "gold") params.metal = "22K Gold";
      else if (category === "diamond") params.gemstone = "Diamond";
      else params.category = category;
    }
    if (metal) params.metal = metal;
    if (gemstone) params.gemstone = gemstone;
    if (maxPrice) params.max_price = maxPrice;
    if (sort) params.sort = sort;
    if (search) params.search = search;
    api.get("/products", { params }).then((r) => setProducts(r.data)).finally(() => setLoading(false));
  }, [category, metal, gemstone, maxPrice, sort, search]);

  const title = search ? `Results for “${search}”` : category ? category.charAt(0).toUpperCase() + category.slice(1) : "All Jewellery";

  return (
    <div data-testid="shop-page" className="max-w-[1400px] mx-auto px-6 lg:px-10 py-12">
      <div className="text-center mb-12">
        <div className="eyebrow">The Boutique</div>
        <h1 className="font-serif-luxe text-4xl sm:text-5xl lg:text-6xl text-[#FAF8F5] mt-3">{title}</h1>
        <p className="mt-3 text-sm text-[#C2B29F]">{products.length} pieces</p>
      </div>

      <div className="flex flex-wrap gap-3 mb-10 justify-center">
        <select data-testid="filter-metal" value={metal} onChange={(e) => setMetal(e.target.value)} className="bg-[#1C130E] border border-[#D4AF37]/25 text-[#FAF8F5] px-4 py-2 text-xs tracking-[0.14em] uppercase">
          <option value="">All Metals</option>
          {METALS.map(m => <option key={m}>{m}</option>)}
        </select>
        <select data-testid="filter-gemstone" value={gemstone} onChange={(e) => setGemstone(e.target.value)} className="bg-[#1C130E] border border-[#D4AF37]/25 text-[#FAF8F5] px-4 py-2 text-xs tracking-[0.14em] uppercase">
          <option value="">All Gemstones</option>
          {GEMSTONES.map(g => <option key={g}>{g}</option>)}
        </select>
        <select data-testid="filter-price" value={maxPrice} onChange={(e) => setMaxPrice(e.target.value)} className="bg-[#1C130E] border border-[#D4AF37]/25 text-[#FAF8F5] px-4 py-2 text-xs tracking-[0.14em] uppercase">
          <option value="">Any Price</option>
          <option value="50000">Under ₹50,000</option>
          <option value="150000">Under ₹1,50,000</option>
          <option value="300000">Under ₹3,00,000</option>
          <option value="500000">Under ₹5,00,000</option>
        </select>
        <select data-testid="sort" value={sort} onChange={(e) => setSort(e.target.value)} className="bg-[#1C130E] border border-[#D4AF37]/25 text-[#FAF8F5] px-4 py-2 text-xs tracking-[0.14em] uppercase">
          <option value="">Newest</option>
          <option value="price-asc">Price: Low to High</option>
          <option value="price-desc">Price: High to Low</option>
          <option value="name-asc">A to Z</option>
        </select>
        {(metal || gemstone || maxPrice || sort || search) && (
          <button onClick={() => { setMetal(""); setGemstone(""); setMaxPrice(""); setSort(""); setSearchParams({}); }} className="text-xs tracking-[0.14em] uppercase text-[#D4AF37] px-4">Clear</button>
        )}
      </div>

      {loading ? (
        <div className="text-center py-24 text-[#C2B29F]">Curating your selection…</div>
      ) : products.length === 0 ? (
        <div className="text-center py-24">
          <div className="font-serif-luxe text-2xl text-[#FAF8F5]">No pieces match your filters.</div>
          <div className="text-[#C2B29F] mt-2">Try broadening your search.</div>
        </div>
      ) : (
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-6 sm:gap-8">
          {products.map((p, i) => <ProductCard key={p.id} product={p} index={i}/>)}
        </div>
      )}
    </div>
  );
}
